import { useState, useEffect } from 'react';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import { _EmployeeBonus, _EmployeeIncapacity, _EmployeeNovelty } from '../../../../../core/services/dataBean/EntityCatalog';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const IncapacityTypeConstantsEditor = ({ idSelector, onChange, label }: Props) => {

    const incapacity = useDataBean(_EmployeeIncapacity)
    const [lista, setLista] = useState<any>([])
    const [id, setID] = useState(null);

    useEffect(() => {
        setID(idSelector);
    }, [idSelector])
    
    useEffect(()=>{
        getLista();
    },[])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(e);
    }

    const getLista = () => {
        incapacity.instance.getIncapacityTypeConstants(null).then(
            (resp) => {
                setLista(resp);
            }
        );
    }


    return (
        <>
            <label>{label ?? "Tipo de Ausentismo"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={null} >...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.Value} >{item.DataBeanProperties.Property}</option>
                        )
                    })
                }
            </select>
        </>
    )
}